// extracted by mini-css-extract-plugin
export default {"textarea":"_1a7K0"};